function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "1.-Rollover-Call-Dashboard",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "1.1.-Rollover-Calls-Mini-App",
  transform: "translate(-784.000000, -527.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(704.000000, 191.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Email",
  transform: "translate(64.000000, 320.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "vpn_key_black_24dp",
  transform: "translate(16.000000, 16.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "0 0 32 0 32 32 0 32"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.8666667,13.3333333 C15.7733333,10.2266667 12.8133333,8 9.33333333,8 C4.92,8 1.33333333,11.5866667 1.33333333,16 C1.33333333,20.4133333 4.92,24 9.33333333,24 C12.8133333,24 15.7733333,21.7733333 16.8666667,18.6666667 L22.6666667,18.6666667 L22.6666667,24 L28,24 L28,18.6666667 L30.6666667,18.6666667 L30.6666667,13.3333333 L16.8666667,13.3333333 Z M9.33333333,18.6666667 C7.86666667,18.6666667 6.66666667,17.4666667 6.66666667,16 C6.66666667,14.5333333 7.86666667,13.3333333 9.33333333,13.3333333 C10.8,13.3333333 12,14.5333333 12,16 C12,17.4666667 10.8,18.6666667 9.33333333,18.6666667 Z",
  id: "Shape",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}))))));

function SvgVpnKeyBlack24Dp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "48F66A27-8E21-4EEF-8ED6-2C16668DDFFB@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVpnKeyBlack24Dp);
export default __webpack_public_path__ + "static/media/vpn_key_black_24dp.d9a3255e.svg";
export { ForwardRef as ReactComponent };